import { CurriculumComponent } from './curriculum/curriculum.component';
import { NgModule } from '@angular/core';
import { AsapCurriculumComponent } from './asap-curriculum.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    NgxMaskModule.forRoot(),
    NgxSkeletonLoaderModule
  ],
  declarations: [
    AsapCurriculumComponent, 
    CurriculumComponent
  ],
  exports: [
    AsapCurriculumComponent,
    CurriculumComponent
  ]
})
export class AsapCurriculumModule { }
